import React, { Component } from 'react'
import HitMesh3D from './hitMesh3D'
import * as THREE from 'three'

export default function HitCircle3D(props) {
    return <HitMesh3D geometry={THREE.CircleBufferGeometry} {...props} />
}
